import { fromHex, zeroAddress } from 'viem';
import { fetchJSON } from '../internal/api.js';
import { getApiUrl } from '../utils/getApiUrl.js';
import { toJSON } from '../utils/toJSON.js';
// getQuote calls the /quote endpoint
export async function getQuote(quote) {
    const { srcChainId, destChainId, deposit: depositInput, expense: expenseInput, mode, environment, } = quote;
    const apiUrl = getApiUrl(environment);
    const json = await fetchJSON(`${apiUrl}/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: toJSON({
            sourceChainId: srcChainId,
            destChainId: destChainId,
            deposit: depositInput
                ? toQuoteUnit(depositInput, mode === 'deposit')
                : {},
            expense: expenseInput
                ? toQuoteUnit(expenseInput, mode === 'expense')
                : {},
        }),
    });
    if (!isQuoteRes(json)) {
        throw new Error(`Unexpected quote response: ${JSON.stringify(json)}`);
    }
    const { deposit, expense } = json;
    return {
        deposit: { ...deposit, amount: fromHex(deposit.amount, 'bigint') },
        expense: { ...expense, amount: fromHex(expense.amount, 'bigint') },
    };
}
// trim params to create obj expected by /quote endpoint
export const toQuoteUnit = (q, omitAmount) => ({
    amount: omitAmount ? undefined : q.amount,
    token: q.token ?? zeroAddress,
});
// asserts a json response is QuoteResponse
function isQuoteRes(json) {
    // TODO: schema validation
    const quote = json;
    return (json != null &&
        quote.deposit != null &&
        quote.expense != null &&
        typeof quote.deposit.token === 'string' &&
        typeof quote.deposit.amount === 'string' &&
        typeof quote.expense.token === 'string' &&
        typeof quote.expense.amount === 'string');
}
//# sourceMappingURL=getQuote.js.map